import React, { useEffect, useState } from 'react';
import { Box, Link, Modal, Stack, Text } from '@stitch-fix/mode-react';
import {
  trackSizeGuideLinkView,
  trackSizeGuideLinkClick,
} from './SizeGuide.tracking';
import { sizeGuideSupported } from './helpers/sizeGuideSupported';
import SizeGuide from './SizeGuide';
import { useProductDetailsPageContext } from '../ProductDetailsPage/ProductDetailsPageContext/ProductDetailsPageContext';

const SizeGuideLinkAndModal = () => {
  const [state] = useProductDetailsPageContext();
  const brand = state.shopProduct?.brand?.name || '';
  const businessLine = state.productBusinessLine || '';
  const [showSizeGuideModal, setShowSizeGuideModal] = useState(false);
  const [linkViewTracked, setLinkViewTracked] = useState(false);
  const [linkClickTracked, setLinkClickTracked] = useState(false);

  const handleModalOpen = (trackClickEvent: boolean) => {
    if (!linkClickTracked && trackClickEvent) {
      trackSizeGuideLinkClick({
        brand,
        businessLine,
        ...state,
      });
      setLinkClickTracked(true);
    }
    setShowSizeGuideModal(true);
  };

  const handleModalClose = () => {
    setShowSizeGuideModal(false);
  };

  useEffect(() => {
    if (!linkViewTracked) {
      trackSizeGuideLinkView({
        brand,
        businessLine,
        ...state,
      });
      setLinkViewTracked(true);
    }
  }, [linkViewTracked, brand, businessLine, state]);

  useEffect(() => {
    if (showSizeGuideModal) {
      handleModalOpen(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (
    !sizeGuideSupported(
      brand,
      businessLine,
      state.shopProduct?.productType?.klass,
      state.shopProduct?.productType?.family,
    ) ||
    state.isStaticView
  ) {
    return null;
  }

  return (
    <Box data-testid="size-guide-container">
      <Link as="button" size="tertiary" onClick={() => handleModalOpen(true)}>
        Size guide
      </Link>
      <Modal
        heading={
          <Stack spacing={0} mb={0.5}>
            <Text height="standard" family="medium" scale="5">
              Size guide
            </Text>
            <Text height="short" family="medium" scale="2">
              {brand.toUpperCase()}
            </Text>
          </Stack>
        }
        isOpen={showSizeGuideModal}
        onClose={handleModalClose}
      >
        <SizeGuide />
      </Modal>
    </Box>
  );
};

export default SizeGuideLinkAndModal;
